/**
 * JamSessionModalWrapper Component
 * Wrapper for Jam Session creation/join modal
 */

import React from 'react';
import { JamSessionModal } from '../jam';

export const JamSessionModalWrapper = ({
  isOpen,
  onClose,
  onSessionJoined,
  userId,
  userName,
  currentProjectId,
}) => {
  return (
    <JamSessionModal
      isOpen={isOpen}
      onClose={onClose}
      onSessionJoined={onSessionJoined}
      userId={userId}
      userName={userName}
      currentProjectId={currentProjectId}
    />
  );
};

export default JamSessionModalWrapper;
